// react
import React, { useEffect, useState } from "react";

// third-party
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet-async";

// application
import PageHeader from "../shared/PageHeader";
import ProductsView from "./ProductsView";
import CategorySidebar from "./CategorySidebar";

// data stubs
import { getSearchProducts } from "../../store/directusSdk";
import { resetFilters } from "../../store/pagesContent";

function ShopSearchProducts(props) {
    const {
        columns,
        viewMode,
        match: { params: product },
        resetFilters,
        filterOn,
    } = props;
    const [state, setState] = useState({ products: [], filters: [], loading: true });

    useEffect(() => {
        console.log(state.products)
        if (filterOn.length > 0) {
            resetFilters();
        }
  

        setState({ products: [], filters: [], loading: true });
        const filtros = Object({
            brand: [],
            model: [],
            amp: [],
            hp: [],
            kw: [],
            voltage: [],
            rpm: [],
            frame: [],
            coil: [],
            polos: [],
            fp: [],
            efficiency: [],
            fs: [],
            type: [],
            connection: [],
            phases: [],
            temperature: [],
            output: [],
            input: [],
            pressure: [],
            flow: [],
            color: [],
            seal: [],
            diameter: [],
            thread: [],
            application: [],
            protection: [],
            mounting: [],
            communication: [],
            pulses: [],
            curve: [],
            capacity: [],
            unit: [],
            rank: [],
            long: [],
            size: [],
        });
        const searchProducts = getSearchProducts(product.string);
        searchProducts.then((res) => {
            if (res.data.length > 0) {
                const products = res.data.map((e) => {
                    let bod01 = 0;
                    let bod05 = 0;
                    if (e.OnHandByWhs) {
                        const bodegas = e.OnHandByWhs.split(",");
                        bod01 = bodegas[0].split(":");
                        bod05 = bodegas[1].split(":");
                    }
                    const features = [];
                    if (e.especificaciones) {
                        const specifications = e.especificaciones.split("<br>").splice(0, 5);
                        specifications.forEach((e) => {
                            if (e !== "") {
                                const specif = e.split(":");
                                features.push({ name: specif[0], value: specif[1] });
                            }
                        });
                    }
                    const images = [];
                    if (e.images !== "") {
                        const imag = e.images.split(",");
                        imag.forEach((img) => {
                            if (img !== "") {
                                images.push(`images/products/${img}`);
                            }
                        });
                    } else {
                        images.push("images/not_found.png");
                    }

                    const pdfs = [];
                    if (e.pdfs !== "") {
                        const pdff = e.pdfs.split(",");
                        pdff.forEach((pdf) => {
                            if (pdf !== "") {
                                pdfs.push(`images/pdfs/${pdf}`);
                            }
                        });
                    }

                    if (!filtros.brand.includes(e.brand) && e.brand) {
                        filtros.brand.push(e.brand);
                    }
                    if (!filtros.model.includes(e.model) && e.model) {
                        filtros.model.push(e.model);
                    }
                    if (!filtros.amp.includes(e.amp) && e.amp) {
                        filtros.amp.push(e.amp);
                    }
                    if (!filtros.hp.includes(e.hp) && e.hp) {
                        filtros.hp.push(e.hp);
                    }
                    if (!filtros.kw.includes(e.kw) && e.kw) {
                        filtros.kw.push(e.kw);
                    }
                    if (!filtros.voltage.includes(e.voltage) && e.voltage) {
                        filtros.voltage.push(e.voltage);
                    }
                    if (!filtros.rpm.includes(e.rpm) && e.rpm) {
                        filtros.rpm.push(e.rpm);
                    }
                    if (!filtros.frame.includes(e.frame) && e.frame) {
                        filtros.frame.push(e.frame);
                    }
                    if (!filtros.coil.includes(e.coil) && e.coil) {
                        filtros.coil.push(e.coil);
                    }
                    if (!filtros.polos.includes(e.polos) && e.polos) {
                        filtros.polos.push(e.polos);
                    }
                    if (!filtros.fp.includes(e.fp) && e.fp) {
                        filtros.fp.push(e.fp);
                    }
                    if (!filtros.efficiency.includes(e.efficiency) && e.efficiency) {
                        filtros.efficiency.push(e.efficiency);
                    }
                    if (!filtros.fs.includes(e.fs) && e.fs) {
                        filtros.fs.push(e.fs);
                    }
                    if (!filtros.type.includes(e.type) && e.type) {
                        filtros.type.push(e.type);
                    }
                    if (!filtros.connection.includes(e.connection) && e.connection) {
                        filtros.connection.push(e.connection);
                    }
                    if (!filtros.phases.includes(e.phases) && e.phases) {
                        filtros.phases.push(e.phases);
                    }
                    if (!filtros.temperature.includes(e.temperature) && e.temperature) {
                        filtros.temperature.push(e.temperature);
                    }
                    if (!filtros.output.includes(e.output) && e.output) {
                        filtros.output.push(e.output);
                    }
                    if (!filtros.input.includes(e.input) && e.input) {
                        filtros.input.push(e.input);
                    }
                    if (!filtros.pressure.includes(e.pressure) && e.pressure) {
                        filtros.pressure.push(e.pressure);
                    }
                    if (!filtros.flow.includes(e.flow) && e.flow) {
                        filtros.flow.push(e.flow);
                    }
                    if (!filtros.color.includes(e.color) && e.color) {
                        filtros.color.push(e.color);
                    }
                    if (!filtros.seal.includes(e.seal) && e.seal) {
                        filtros.seal.push(e.seal);
                    }
                    if (!filtros.diameter.includes(e.diameter) && e.diameter) {
                        filtros.diameter.push(e.diameter);
                    }
                    if (!filtros.thread.includes(e.thread) && e.thread) {
                        filtros.thread.push(e.thread);
                    }
                    if (!filtros.application.includes(e.application) && e.application) {
                        filtros.application.push(e.application);
                    }
                    if (!filtros.protection.includes(e.protection) && e.protection) {
                        filtros.protection.push(e.protection);
                    }
                    if (!filtros.mounting.includes(e.mounting) && e.mounting) {
                        filtros.mounting.push(e.mounting);
                    }
                    if (!filtros.pulses.includes(e.pulses) && e.pulses) {
                        filtros.pulses.push(e.pulses);
                    }
                    if (!filtros.communication.includes(e.communication) && e.communication) {
                        filtros.communication.push(e.communication);
                    }
                    if (!filtros.pulses.includes(e.pulses) && e.pulses) {
                        filtros.pulses.push(e.pulses);
                    }
                    if (!filtros.curve.includes(e.curve) && e.curve) {
                        filtros.curve.push(e.curve);
                    }
                    if (!filtros.capacity.includes(e.capacity) && e.capacity) {
                        filtros.capacity.push(e.capacity);
                    }
                    if (!filtros.unit.includes(e.unit) && e.unit) {
                        filtros.unit.push(e.unit);
                    }
                    if (!filtros.rank.includes(e.rank) && e.rank) {
                        filtros.rank.push(e.rank);
                    }
                    if (!filtros.long.includes(e.long) && e.long) {
                        filtros.long.push(e.long);
                    }
                    if (!filtros.size.includes(e.size) && e.size) {
                        filtros.size.push(e.size);
                    }
                    const product = Object.assign({}, e);
                    product.days = parseInt(e.days);
                    product.bod01 = parseInt(bod01[1]);
                    product.bod05 = parseInt(bod05[1]);
                    product.compareAtPrice = null;
                    product.images = images;
                    product.pdfs = pdfs;
                    product.features = features;
                    return product;
                });
                const filters = [];
                Object.entries(filtros).forEach((e, i) => {
                    if (e[1].length > 0) {
                        filters.push({
                            id: i,
                            name: e[0],
                            type: "select",
                            options: e[1],
                        });
                    }
                });
                setState({ products, filters, loading: false });
            } else {
                setState({ products: [], filters: [], loading: false });
            }
        });
    }, [product.string]);
    const breadcrumb = [
        { title: "Home", url: "/" },
        { title: "Busqueda", url: "" },
    ];
    let content;
    const offcanvas = columns === 3 ? "mobile" : "always";

    if (columns > 3) {
        content = (
            <div className="container">
                <div className="block">
                    <CategorySidebar filters={state.filters} offcanvas={offcanvas} subcatId={product.string} />
                    <ProductsView
                        products={state.products}
                        layout={viewMode}
                        grid={`grid-${columns}-full`}
                        limit={15}
                        offcanvas={offcanvas}
                        filters={state.filters}
                    />
                </div>
            </div>
        );
    } else {
        
        content = (
            <div className="container">
                <div className="shop-layout__content">
                    <div className="block">
                        <ProductsView products={state.products} layout={viewMode} grid="grid-3-sidebar" limit={15} offcanvas={offcanvas} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <Helmet>
                <title> Buscar Productos - ICAutomatizados</title>
            </Helmet>
    
            <PageHeader header={` " ${product.string} "`} breadcrumb={breadcrumb} />
            {state.loading ? (
                <div className="container">
                    <br />
                    <br />
                    <br />
                    <div className="div-loading" />
                    <br />
                    <br />
                    <br />
                </div>
            ) : (
                state.products.length === 0 ? (
                    <div className="container">
                        <h2 style={{heigth:"500px"}} >No se encontraron resultados para "{product.string}".</h2>
                    </div>
                ) : (
                    content
                )
            )}
        </React.Fragment>
    );
    
}

ShopSearchProducts.propTypes = {
    /**
     * number of product columns (default: 3)
     */
    columns: PropTypes.number,
    /**
     * mode of viewing the list of products (default: 'grid')
     * one of ['grid', 'grid-with-features', 'list']
     */
    viewMode: PropTypes.oneOf(["grid", "grid-with-features", "list"]),
    /**
     * sidebar position (default: 'start')
     * one of ['start', 'end']
     * for LTR scripts "start" is "left" and "end" is "right"
     */
    sidebarPosition: PropTypes.oneOf(["start", "end"]),
};

ShopSearchProducts.defaultProps = {
    columns: 4,
    viewMode: "grid",
    sidebarPosition: "start",
};
const mapStateToProps = (state) => ({
    filterOn: state.pagesContent.filters,
});

const mapDispatchToProps = {
    resetFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopSearchProducts);
